import styled from 'styled-components';

import Card from '../../atoms/Card';

export const Label = styled.span`
  color: black;
`;

export const DateRangeText = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  font-size: 14px;
`;

export const DateRangeWrapper = styled(Card)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  border-radius: 0;
  box-shadow: none;
  padding: 6px 0;

  @media (min-width: 1025px) {
    padding: 6px;
  }

  white-space: nowrap;
  background-color: transparent;

  &:hover {
    box-shadow: none;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 21px;
  font-weight: 600;
  font-family: 'Roboto';
  color: #000;

  @media (min-width: 1025px) {
    padding-left: 4px;
    margin-bottom: 8px;
  }

  @media (min-width: 1921px) {
    margin-bottom: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;

  @media (min-width: 1025px) {
    flex-direction: row;
    gap: 14px;
    margin-top: 24px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;

  @media (min-width: 1025px) {
    padding: 0 16px;
  }

  @media (min-width: 1921px) {
    gap: 24px;
    padding: 0 24px;
  }
`;

export const IndicatorsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: start;
  width: 100%;
  margin-bottom: 16px;
  flex-wrap: wrap;

  @media (min-width: 1280px) {
    flex-wrap: initial;
    margin-bottom: 24px;
  }

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 50px rgba(224, 224, 224, 1);
    box-shadow: inset 0 0 50px rgba(224, 224, 224, 1);
  }

  .range_picker {
    position: absolute;
    z-index: 1;
    left: 12vw;
    top: 10px;
    border: none;
    background-color: #fff;
    height: 35px;
    box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
    margin-right: 10px;
    width: 230px;

    &:hover {
      cursor: pointer;
      border: none;
      box-shadow: 0 0 4px -1px rgba(0, 0, 0, 0.1);
    }
  }
`;

export const IndicatorsPortraitWrapper = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;

  @media (min-width: 1025px) {
    gap: 2.6%;
  }
`;

export const WrapperIcon = styled.span`
  margin-right: 16px;
`;

export const DataRangeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DataRangeSelect = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const Skeleton = styled.div`
  .ant-skeleton {
    position: relative;
    min-height: 150px;
    border-radius: 3px;
    width: 100%;
    background-clip: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;

    @media (min-width: 1025px) {
      min-height: 31.6%;
      min-width: 320px;
      height: 142.84px;
    }
  }

  .ant-skeleton-button {
    position: relative;
    padding: 16px;
    min-height: 150px;
    border-radius: 3px;
    width: 100%;
    background-clip: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;

    @media (min-width: 1025px) {
      min-height: 31.6%;
      min-width: 320px;
      height: 142.84px;
    }
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BarsWrapper = styled.div`
  svg {
    position: absolute;
    opacity: 0.1;
    bottom: 0;
    left: 0;
  }

  display: none;

  @media (min-width: 1025px) {
    display: block;
  }
`;

export const Legend = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const WaverUpWrapper = styled.div`
  svg {
    position: absolute;
    opacity: 0.1;
    bottom: 0;
    left: 0;
  }

  display: none;

  @media (min-width: 1025px) {
    display: block;
  }
`;

export const WaverDownWrapper = styled.div`
  svg {
    position: absolute;
    opacity: 0.1;
    bottom: 0;
    left: 0;
  }

  display: none;

  @media (min-width: 1025px) {
    display: block;
  }
`;

export const SkeletonPortrait = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;

  @media (min-width: 1025px) {
    gap: 2.6%;
  }

  .ant-skeleton {
    position: relative;
    min-height: 146.5px;
    border-radius: 3px;
    width: 100%;
    background-clip: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;

    @media (min-width: 1025px) {
      height: 100%;
      min-width: 260px;
    }
  }

  .ant-skeleton-button {
    position: relative;
    padding: 16px;
    min-height: 146.5px;
    border-radius: 3px;
    width: 100%;
    background-clip: border-box;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;

    @media (min-width: 1025px) {
      height: 100%;
      min-width: 260px;
    }
  }
`;

export const TitleWithNormalText = styled.span`
  text-transform: initial;
`;
